import axios from 'axios';
import { API_GUEST_SESSION, API_GUEST_VALIDATE } from './apiConst';
import { manageObjectResponse } from './apiResponse';
import { getLogger } from '../logger';

const debug = getLogger('services:api:guestApi');

export let validateGuestCode = code => {
  if (code) {
    return manageObjectResponse(axios.post(API_GUEST_VALIDATE, { code }, { preventInterceptors: true }));
  }
  debug.error('[validateGuestCode] code is empty');
};

export let createGuestSession = (code, name, email) => {
  if (code) {
    // classroom-be valida name/email con Joi.string(), que rechaza strings vacíos: solo se envían si tienen valor
    const payload = { code };
    if (name && name.trim()) {
      payload.name = name.trim();
    }
    if (email && email.trim()) {
      payload.email = email.trim();
    }
    return manageObjectResponse(axios.post(API_GUEST_SESSION, payload, { preventInterceptors: true }));
  }
  debug.error('[createGuestSession] code is empty');
};
